import { useTranslation } from 'react-i18next';
import { formatNumber } from '@/app/shared/utils';
import { useCustomSelector } from '@/core/redux/hooks';
import {
	Close,
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	ScrollArea,
	CoinImage,
} from '@/app/shared/components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface LeaderBoardProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NewLeaderBoard: React.FC<LeaderBoardProps> = ({
	isOpen,
	onClose,
}: LeaderBoardProps) => {
	const { t } = useTranslation();

	const { leaderboard } = useCustomSelector((state) => state.leaderboard);
	let userRank =useCustomSelector((state)=>state.leaderboard.userRank)
    return (
		<Drawer open={isOpen} onOpenChange={onClose} direction="right">
			<DrawerContent>
				<div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" />
				<div className="mx-auto w-full max-w-sm ">
					<DrawerHeader>
						<DrawerTitle>
							<VisuallyHidden>
								{t('dailycombo.reveal.title')}
							</VisuallyHidden>
							<DrawerClose className="right-5 text-right absolute">
								<Close fillcolor="#fff" />
							</DrawerClose>
						</DrawerTitle>
					</DrawerHeader>
					<DrawerDescription>
						<VisuallyHidden></VisuallyHidden>
					</DrawerDescription>

					<div>
						<div className="text-center my-4">
							<h1 className="text-2xl font-bold text-white">🏆 {t('leaderboard.heading')}</h1>
						</div>
						<ScrollArea className="h-[calc(100dvh-120px)] w-full px-3 flex flex-col mx-auto mt-2">
							<div className="text-center my-4">
								<p className="text-sm text-gray-300 mt-1">
									Your current rank: <span className="text-pink-400 font-semibold">#{userRank}</span>
								</p>
							</div>
							<div className="flex flex-col mx-auto py-4 gap-4 px-4">
								{leaderboard.map((item, keyn) => {
									return (
										<div
											key={keyn+1}
											className="flex rounded-2xl items-center bg-customer-900/50 p-2 option-menu-setting py-3 "
										>
											<div className="flex flex-1 gap-2 items-center">
												<p className="text-[10px] font-bold">
													{keyn+1}
												</p>

												<p className="text-[10px] font-bold">
													{item.userId}
												</p>
											</div>

											<div className="flex gap-2">
												<div className="flex gap-1 items-center">
													<p className="text-[10px]">
														{formatNumber(Math.trunc(item.points ? item.points : 0))}
													</p>

													<CoinImage classes="drop-shadow-sm w-[20px]" />
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</ScrollArea>
					</div>
					<DrawerFooter>
						<DrawerClose asChild></DrawerClose>
					</DrawerFooter>
				</div>
				<div className="absolute bottom-6 left-1/2 -translate-x-1/2 
                px-8 py-3 rounded-full 
                bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 
                text-white font-bold shadow-md 
                hover:shadow-lg hover:scale-105 
                transition-all duration-200">
  Version 1.0.3
</div>
				{/* <div className="mx-auto my-6 w-fit px-8 py-3 rounded-full bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white font-bold shadow-md hover:shadow-lg hover:scale-105 transition-all duration-200">Version 1.0.1</div> */}
			</DrawerContent>
		</Drawer>
)}